import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { TVData } from "../../utils/types/app.types";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store.ts";
import { FetchAPIData } from "../../utils/GlobalFunctions/fetch.ts";
import SliderModule from "../../components/SliderModule/index.tsx";
import MediaCastSection from "../../components/MediaCastSection/index.tsx";
import { normalizeTvAggregateCast } from "../../components/MediaCastSection/castUtils.ts";
import TvSeasonsSection from "../../components/TvSeasonsSection/index.tsx";
import MediaReviewsSection from "../../components/MediaReviewsSection/index.tsx";

const TvDetailsPage: React.FC = () => {
  const sessionData = useSelector((state: RootState) => state.session);
  const [tvDetails, setTvDetails]: any = useState({});
  const { tvId } = useParams();
  const location = useLocation();

  // Get URL parameters
  const searchParams = new URLSearchParams(location.search);
  const fromGenre = searchParams.get('from') === 'genre';
  const genreName = searchParams.get('genreName');
  const genreId = searchParams.get('genreId');
  const mediaType = searchParams.get('mediaType');

  //console.log(`${tvId}`);
  useEffect(() => {
    //console.log(global.api.apiKey);
    const intiliaze = async () => {
      const newTvDetails = await FetchAPIData(`tv/${tvId}`, sessionData, {
        append_to_response: "aggregate_credits",
      });

      //TODO Create response validation check to & show error message if it fails

      setTvDetails(newTvDetails);
    };
    intiliaze();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tvId, sessionData]);

  // Determine back button text and link
  const getBackButton = () => {
    if (fromGenre && genreName && genreId && mediaType) {
      return (
        <Link className="btn" to={`/genres/${mediaType}/${genreId}`}>
          ← Back to {genreName}
        </Link>
      );
    }
    
    return (
      <Link className="btn" to="/shows">
        ← Back to TV Shows
      </Link>
    );
  };

  return (
    <>
      {/*<section>
                <h1>Amazing scientists 8 - {global.currentPage}</h1>
            </section>*/}

      <section className="container media-details-page">
        <div id="movie-details" className="media-details">
          {Object.keys(tvDetails).length > 0 && tvDetails.backdrop_path && (
            <div
              className="movie-details-backdrop"
              style={{
                backgroundImage: `linear-gradient(
                  180deg,
                  rgba(2, 13, 24, 0.62) 0%,
                  rgba(2, 13, 24, 0.5) 45%,
                  rgba(2, 13, 24, 0.68) 100%
                ), url("https://image.tmdb.org/t/p/original/${tvDetails.backdrop_path}")`,
              }}
            ></div>
          )}

          <div className="back">{getBackButton()}</div>

          {/* Movie Details Output */}
          {Object.keys(tvDetails).length && (
            <div>
              <div className="details-top">
                <div>
                  <img
                    src={
                      typeof tvDetails.poster_path === "string" &&
                      tvDetails.poster_path.length
                        ? `https://image.tmdb.org/t/p/w500${tvDetails.poster_path}`
                        : "../images/no-image.jpg"
                    }
                    className="card-img-top"
                    alt={tvDetails.title}
                  />
                </div>
                <div style={{ marginLeft: "30px" }}>
                  <h2 style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                    {tvDetails.name}
                  </h2>
                  <p>
                    <FontAwesomeIcon
                      icon={faStar}
                      style={{ color: "#f1c40f" }}
                    />
                    &nbsp;
                    {Number(tvDetails.vote_average ?? 0).toFixed(1)} / 10
                  </p>
                  <p className="text-muted">
                    Last Air Date: {tvDetails.last_air_date}
                  </p>
                  <p>{tvDetails.overview}</p>
                  <h5>Genres</h5>
                  <ul className="list-group">
                    {(tvDetails.genres || []).map(
                      (genre: TVData & { id?: number }) => (
                        <li key={genre.id ?? genre.name}>{genre.name}</li>
                      ),
                    )}
                  </ul>
                  <a
                    href={tvDetails.homepage}
                    target="_blank"
                    rel="noreferrer"
                    className="btn"
                  >
                    Visit Show Homepage
                  </a>
                </div>
              </div>
              <div className="details-bottom">
                <h2>Show Info</h2>
                <ul>
                  <li>
                    <span className="text-secondary">
                      Number of Episodes:&nbsp;{" "}
                    </span>
                    {tvDetails.number_of_episodes}
                  </li>
                  <li>
                    <span className="text-secondary">
                      Last Episode To Air:&nbsp;{" "}
                    </span>
                    {tvDetails.last_episode_to_air?.name ?? "—"}
                  </li>
                  <li>
                    <span className="text-secondary">Status:&nbsp; </span>{" "}
                    {tvDetails.status}
                  </li>
                </ul>
                <h4 style={{ fontWeight: "bold" }}>Production Companies</h4>
                <div className="list-group">
                  {(tvDetails.production_companies || []).map(
                    (
                      company: { id?: number; name: string },
                      index: number,
                      arr: { name: string }[],
                    ) => {
                      const comp_name =
                        index + 1 === arr.length
                          ? company.name
                          : company.name + ",";
                      return (
                        <span key={company.id ?? index}>{comp_name + " "}</span>
                      );
                    },
                  )}
                </div>
              </div>
              <TvSeasonsSection
                tvId={tvId}
                seasons={tvDetails.seasons || []}
              />
              <MediaReviewsSection mediaType="tv" mediaId={tvId} />
              <MediaCastSection
                cast={normalizeTvAggregateCast(
                  tvDetails.aggregate_credits?.cast,
                )}
              />
            </div>
          )}
        </div>
      </section>
      <SliderModule id={tvId || ""} mediaType="tv" />
    </>
  );
};
export default TvDetailsPage;
